// Single-open accordion for the product page's FAQ panel.
//
// Focal ships `collapsible-content`, but that element is a disclosure: each
// one opens and closes on its own, and the product tabs already force every
// instance of it open at every viewport (see kludi-product-content.css), so
// reusing it here would mean fighting the rule that makes the tab panels
// work. The design's FAQ is a different mechanism anyway -- exactly one
// answer is open at a time, and clicking the open question closes it and
// leaves none open.
//
// The panel is delegated rather than per-button so the answers can be swapped
// by the theme editor without rebinding, and so a question added to the block
// mid-session still responds.
(() => {
  const QUESTION = '[data-kludi-faq-question]';

  function answerFor(question) {
    const id = question.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setOpen(question, open) {
    question.setAttribute('aria-expanded', open ? 'true' : 'false');
    const answer = answerFor(question);
    if (answer) answer.toggleAttribute('hidden', !open);
  }

  document.addEventListener('click', (event) => {
    const question = event.target.closest(QUESTION);
    if (!question) return;

    const panel = question.closest('.kludi-product-faq');
    if (!panel) return;

    const wasOpen = question.getAttribute('aria-expanded') === 'true';

    // closing every sibling first, including the one just clicked, keeps the
    // "click the open question to close it" case from re-opening itself
    panel.querySelectorAll(QUESTION).forEach((other) => setOpen(other, false));
    if (!wasOpen) setOpen(question, true);
  });
})();
